import { useEffect, useMemo } from 'react';
import { useMediaQuery, usePrevious, useSportUrlParams } from '@mwl/core-lib';

import { selectShowTabletSportSidebar, setShowTabletSportSidebar } from '@/store';

import { useTypedDispatch } from './useTypedDispatch';
import { useTypedSelector } from './useTypedSelector';

import variables from '@/styles/helpers/export.module.scss';

export const useSportSidebarBehavior = () => {
  const dispatch = useTypedDispatch();

  const isTabletScreen = useMediaQuery(
    `(min-width: ${variables.screen850}) and (max-width: calc(${variables.screen1284} - 1px))`,
  );

  const showTabletSportSidebar = useTypedSelector(selectShowTabletSportSidebar);

  const { sportId } = useSportUrlParams();

  const prevSportId = usePrevious(sportId);

  const sidebarIsOpened = useMemo(() => {
    if (!isTabletScreen) {
      return !!sportId;
    }

    return isTabletScreen && showTabletSportSidebar && !!sportId;
  }, [isTabletScreen, showTabletSportSidebar, sportId]);

  useEffect(() => {
    if (isTabletScreen && !showTabletSportSidebar && sportId !== prevSportId) {
      dispatch(setShowTabletSportSidebar(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTabletScreen, showTabletSportSidebar, sportId]);

  return {
    sidebarIsOpened,
    sportId,
    isTabletScreen,
  };
};
